import { signal } from "../net/signal";

/**
 * آدمکِ منچ: ۰ پسر، ۱ دختر (کاربر، ۲۵ اکتبر ۲۰۲۶: «بازیکن آدمکِ دختر را هم انتخاب کند»).
 *
 * مثلِ چهره سلیقه‌ی همین دستگاه است و در localStorage می‌مانَد؛ با Hello (و اگر وصل بودیم با SetPiece) به سرور
 * می‌رود و سرور آن را به صندلی می‌چسباند تا بقیه هم دخترِ ما را ببینند. ربات‌ها از چهره‌شان می‌گیرند (سرور).
 */
const KEY = "bazivan.mench.piece";

function load(): number {
  try { return localStorage.getItem(KEY) === "1" ? 1 : 0; } catch { return 0; }
}

export const menchPiece = signal<number>(load());

export function saveMenchPiece(p: number): void {
  menchPiece.value = p === 1 ? 1 : 0;
  try { localStorage.setItem(KEY, String(menchPiece.value)); } catch { /* بی‌ذخیره هم کار می‌کند */ }
}
